import React from "react";
import "./style.css";
import UsersImage from "../../Images/signIn/user.png";
import PwImage from "../../Images/signIn/pw.png";
import Logo from "../../Images/logo.png";
import { Label } from "reactstrap";
import { Button } from "antd";

class LoginPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			signInEmail: "",
			signInPassword: "",
			errors: {},
			loadings: [],
		};
	}

	componentDidMount() {
		const listener = (event) => {
			if (event.code === "Enter" || event.code === "NumpadEnter") {
				// console.log("Enter key was pressed. Run your function.");
				this.onSubmitSignIn();
			}
		};
		document.addEventListener("keydown", listener);
		return () => {
			document.removeEventListener("keydown", listener);
		};
	}

	onEmailChange = (event) => {
		this.setState({ signInEmail: event.target.value });
	};

	onPasswordChange = (event) => {
		this.setState({ signInPassword: event.target.value });
	};

	onSubmitSignIn = () => {
		if (
			this.state.signInEmail === "admin" &&
			this.state.signInPassword === "admin"
		) {
			// this.props.login(true);
		} if (this.state.signInEmail !== "admin") {
			this.setState(({ loadings }) => {
				const newLoadings = [...loadings];
				newLoadings[0] = true;

				return {
					loadings: newLoadings,
				};
			});

			fetch(
				"https://sbhs-web-server.herokuapp.com/lte/user/login",
				// "http://localhost:4000/lte/user/login",
				{
					method: "post",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({
						email: this.state.signInEmail,
						password: this.state.signInPassword,
					}),
				}
			)
				.then((response) => response.json())
				.then((response) => {
					// console.log(response)
					if (response._id) {
						setTimeout(() => {
							this.setState(({ loadings }) => {
								const newLoadings = [...loadings];
								newLoadings[0] = false;

								return {
									loadings: newLoadings,
								};
							});
						}, 6000);
						this.props.onRouteChange("home");
						// this.props.setUserData(response);
						// console.log(response);
						// console.log(this.state);
					} else {
						this.setState({
							errors: response,
						});
						setTimeout(() => {
							this.setState(({ loadings }) => {
								const newLoadings = [...loadings];
								newLoadings[0] = false;

								return {
									loadings: newLoadings,
								};
							});
						}, 0);
					}
					// console.log(this.state);
				});
		}
	};

	render() {
		const { errors } = this.state;
		return (
			<div className="signinPage ">
				<div className="signinButtonContainer tc">
					<div className="signinLogo animate__animated animate__rotateIn">
						<img src={Logo} alt="Logo " width="100px" />
					</div>
					<img src={UsersImage} alt="Locked" width="20px" />
					<input
						className="signinInput tc input-reset animate__animated animate__lightSpeedInLeft"
						type="email"
						name="email-address"
						id="email-address"
						placeholder="Email"
						onChange={this.onEmailChange}
					/>
					<Label className="red">{errors.email}</Label>
					<br />
					<img src={PwImage} alt="Locked" width="20px" />
					<input
						className="signinInput tc input-reset animate__animated animate__lightSpeedInRight"
						type="password"
						name="password"
						placeholder="Password"
						id="password"
						onChange={this.onPasswordChange}
					/>
					<Label className="red">{errors.password}</Label>
					<br />
					<Button
						onClick={this.onSubmitSignIn}
						className="signinButtonLogin animate__animated animate__lightSpeedInLeft"
						loading={this.state.loadings[0]}
					>
						Sign in
					</Button>
					<br />
					<Label className="signinButtonLabel tc animate__animated animate__lightSpeedInRight">
						Beta Phase
						<b>(2.3)</b>
					</Label>
				</div>
			</div>
		);
	}
}

  export default LoginPage;
  
